import { eLookupActionTypes } from "./types";
import { ILookup } from "../../model";

export const setLookup = (lookup: ILookup) => ({
  type: eLookupActionTypes.SET_LOOKUP,
  payload: lookup
});
